import { render, staticRenderFns } from "./VesselSeatsList.vue?vue&type=template&id=1f857dd8"
import script from "./VesselSeatsList.vue?vue&type=script&lang=js"
export * from "./VesselSeatsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports